module.exports = __webpack_public_path__ + "img/carshina22_26.542b2760.jpg";